/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react';
import {observer} from 'mobx-react';
import {useStore} from '../../../../store/store';
import io from 'socket.io-client';

const TELEGRAM_AUTH_URL = 'https://oauth.telegram.org/auth';
const TELEGRAM_DEFAULT_SCOPE = 'profile write';
const TEMP_TOKEN_TTL_MS = 5 * 60 * 1000;
const TEMP_TOKEN_CLOCK_SKEW_MS = 60 * 1000;
const NETWORK_ERROR_MESSAGE = 'Ошибка с сетью';
const TEMP_TOKEN_ALREADY_USED = 'TEMP_TOKEN_ALREADY_USED';
const TEMP_TOKEN_NOT_ACTIVE = 'TEMP_TOKEN_NOT_ACTIVE';
const TELEGRAM_SCOPE_ALIASES = {
  openid: null,
  'telegram:bot_access': 'write',
};

const TELEGRAM_CHOICE_MODAL_STYLES = `
  .telegram-choice-modal {
    position: fixed;
    inset: 0;
    z-index: 1050;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    background: #111115;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .telegram-choice-modal__panel {
    position: relative;
    width: min(450px, calc(100vw - 32px));
    height: 267px;
    box-sizing: border-box;
    border: 0;
    border-radius: 30px;
    background: #18181C;
    padding: 54px 54px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .telegram-choice-modal__close {
    position: absolute;
    top: clamp(18px, 2.3vw, 38px);
    right: clamp(18px, 2.3vw, 38px);
    width: 32px;
    height: 32px;
    border: 0;
    padding: 0;
    background: transparent;
    color: #4D5663;
    font-family: Inter, sans-serif;
    font-size: 32px;
    font-weight: 300;
    line-height: 32px;
    cursor: pointer;
    transition: color 160ms ease, transform 160ms ease;
  }

  .telegram-choice-modal__close:hover {
    color: #45C4FF;
    transform: rotate(90deg);
  }

  .telegram-choice-modal__close:focus-visible,
  .telegram-choice-modal__button:focus-visible {
    outline: 2px solid #8BDBFF;
    outline-offset: 4px;
  }

  .telegram-choice-modal__content {
    width: 342px;
    max-width: calc(100vw - 40px);
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .telegram-choice-modal__icon {
    position: absolute;
    top: -37px;
    left: 50%;
    width: 74px;
    height: 74px;
    margin: 0;
    border-radius: 50%;
    background: linear-gradient(180deg, #45C4FF 0%, #2297D5 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    transform: translateX(-50%);
  }

  .telegram-choice-modal__icon svg {
    width: 44px;
    height: 44px;
  }

  .telegram-choice-modal__title {
    width: 342px;
    max-width: 100%;
    box-sizing: border-box;
    margin: 0 0 18px;
    padding-left: 8px;
    border-left: 4px solid #45C4FF;
    color: #FFFFFF;
    font-family: Inter, sans-serif;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .telegram-choice-modal__button {
    display: flex;
    width: 342px;
    max-width: 100%;
    box-sizing: border-box;
    padding: 12px 24px;
    justify-content: center;
    align-items: center;
    border-radius: 50px;
    font-family: Inter, sans-serif;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    cursor: pointer;
    transition: background 160ms ease, border-color 160ms ease, color 160ms ease, transform 160ms ease, opacity 160ms ease;
  }

  .telegram-choice-modal__button:hover {
    transform: translateY(-1px);
  }

  .telegram-choice-modal__button:active {
    transform: translateY(0);
  }

  .telegram-choice-modal__button--app {
    border: 0;
    background: #45C4FF;
    color: #18181c;
    margin-bottom: 12px;
  }

  .telegram-choice-modal__button--app:hover {
    background: #72D3FF;
  }

  .telegram-choice-modal__button--web {
    border: 2px solid #45C4FF;
    background: transparent;
    color: #45C4FF;
  }

  .telegram-choice-modal__button--web:hover {
    border-color: #72D3FF;
    background: rgba(69, 196, 255, 0.12);
    color: #72D3FF;
  }

  .telegram-choice-modal__button--close {
    width: auto;
    min-height: auto;
    padding: 0;
    border: 0;
    border-radius: 0;
    background: transparent;
    color: #FF405A;
    margin-top: 14px;
  }

  .telegram-choice-modal__button--close:hover {
    background: transparent;
    color: #FF6B7F;
  }

  @media (max-width: 480px) {
    .telegram-choice-modal__panel {
      width: calc(100vw - 32px);
      height: 267px;
      padding: 54px 24px 24px;
    }

    .telegram-choice-modal__content {
      width: min(342px, calc(100vw - 32px));
    }

    .telegram-choice-modal__icon {
      top: -37px;
      width: 74px;
      height: 74px;
    }

    .telegram-choice-modal__icon svg {
      width: 44px;
      height: 44px;
    }
  }

  @media (max-height: 520px) {
    .telegram-choice-modal__panel {
      height: 248px;
      padding-top: 44px;
      padding-bottom: 22px;
    }

    .telegram-choice-modal__icon {
      top: -30px;
      width: 60px;
      height: 60px;
    }

    .telegram-choice-modal__icon svg {
      width: 36px;
      height: 36px;
    }

    .telegram-choice-modal__title {
      margin-bottom: 12px;
    }

    .telegram-choice-modal__button--app {
      margin-bottom: 10px;
    }

    .telegram-choice-modal__button--close {
      margin-top: 10px;
    }
  }
`;

const getTelegramScopes = (scope) => {
  const scopes = (scope || TELEGRAM_DEFAULT_SCOPE)
    .split(/\s+/)
    .map((item) => TELEGRAM_SCOPE_ALIASES[item] ?? item)
    .filter(Boolean);

  return [...new Set(scopes)];
};

const getTelegramOidcScope = (scope) => {
  const requestedScopes = getTelegramScopes(scope);
  const oidcScopes = ['openid'];

  if (!requestedScopes.length || requestedScopes.includes('profile')) {
    oidcScopes.push('profile');
  }

  if (requestedScopes.includes('phone')) {
    oidcScopes.push('phone');
  }

  if (requestedScopes.includes('write')) {
    oidcScopes.push('telegram:bot_access');
  }

  return oidcScopes.join(' ');
};

const decodeJwtPayload = (token) => {
  try {
    const [, payload] = token.split('.');
    const normalizedPayload = payload.replace(/-/g, '+').replace(/_/g, '/');
    const paddedPayload = normalizedPayload.padEnd(
      normalizedPayload.length + ((4 - (normalizedPayload.length % 4)) % 4),
      '='
    );

    return JSON.parse(window.atob(paddedPayload));
  } catch (error) {
    return null;
  }
};

const buildTelegramAuthResult = (data) => {
  if (data?.error) {
    return {error: data.error};
  }

  const idToken = data?.result;

  if (!idToken || typeof idToken !== 'string') {
    return {error: 'missing id_token'};
  }

  const user = decodeJwtPayload(idToken);

  if (!user) {
    return {error: 'malformed id_token'};
  }

  return {id_token: idToken, user};
};

const isTelegramUserNotFoundResult = (result) => {
  const numericValues = [result?.http_status, result?.status, result?.data?.status];

  if (numericValues.includes(404)) {
    return true;
  }

  const values = [
    result?.code,
    result?.error,
    result?.status,
    result?.message,
    result?.data?.code,
    result?.data?.error,
    result?.data?.status,
    result?.data?.reason,
  ];

  return values.some((value) => {
    if (typeof value !== 'string' && typeof value !== 'number') {
      return false;
    }

    const normalizedValue = String(value).toLowerCase();
    return (
      normalizedValue === '404' ||
      normalizedValue.includes('not_found') ||
      normalizedValue.includes('not found') ||
      normalizedValue.includes('не найден')
    );
  });
};

const redirectToAuthPage = () => {
  if (window.location.pathname !== '/auth') {
    window.location.replace('/auth');
    return;
  }

  window.history.replaceState({}, document.title, '/auth');
};

const getPopupFeatures = (width, height) => {
  const left = Math.max(0, (window.screen.width - width) / 2 + (window.screen.availLeft || 0));
  const top = Math.max(0, (window.screen.height - height) / 2 + (window.screen.availTop || 0));

  return [
    'popup=yes',
    `width=${width}`,
    `height=${height}`,
    `left=${left}`,
    `top=${top}`,
    'status=0',
    'location=0',
    'menubar=0',
    'toolbar=0',
  ].join(',');
};

const openTelegramAuthWindow = (url) => {
  const popup = window.open(url, 'panely_telegram_auth', getPopupFeatures(520, 720));

  if (popup) {
    popup.focus();
  }

  return popup;
};

const isMobileDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || '';

  return (
    /android|iphone|ipad|ipod|iemobile|opera mini/i.test(userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
};

const getTelegramBotUsername = () => {
  try {
    const url = new URL(process.env.REACT_APP_TELEGRAM);
    return url.pathname.replace(/^\/+/, '').split('/')[0];
  } catch (error) {
    return String(process.env.REACT_APP_TELEGRAM || '').replace(/^@/, '').split('/').pop();
  }
};

const getTelegramBotUrl = (token) => `${process.env.REACT_APP_TELEGRAM}?start=${encodeURIComponent(token)}`;

const getTelegramBotDeepLink = (token) => {
  const username = getTelegramBotUsername();
  return `tg://resolve?domain=${encodeURIComponent(username)}&start=${encodeURIComponent(token)}`;
};

const getTelegramWebUrl = (token) => {
  const tgAddress = getTelegramBotDeepLink(token);
  return `https://web.telegram.org/k/#?tgaddr=${encodeURIComponent(tgAddress)}`;
};

const openTelegramPopup = ({clientId, scope, nonce, onResult}) => {
  const redirectUri = `${window.location.origin}${window.location.pathname}`;
  const params = new URLSearchParams({
    response_type: 'post_message',
    client_id: String(clientId),
    redirect_uri: redirectUri,
    scope: getTelegramOidcScope(scope),
    nonce,
    lang: 'ru',
  });

  const width = 550;
  const height = 650;
  const features = getPopupFeatures(width, height);

  let authFinished = false;
  let popupCheckTimeout;
  const popup = window.open(
    `${TELEGRAM_AUTH_URL}?${params.toString()}`,
    `telegram_oidc_login_${nonce}`,
    features
  );

  const cleanup = () => {
    window.removeEventListener('message', messageHandler);
    window.clearTimeout(popupCheckTimeout);
  };

  const fireResult = (result) => {
    if (authFinished) {
      return;
    }

    authFinished = true;
    cleanup();
    onResult(result);
  };

  const checkPopupClosed = () => {
    if (!popup || popup.closed) {
      fireResult({error: 'popup_closed'});
      return;
    }

    popupCheckTimeout = window.setTimeout(checkPopupClosed, 200);
  };

  function messageHandler(event) {
    if (event.origin !== 'https://oauth.telegram.org' || event.source !== popup) {
      return;
    }

    let data;

    try {
      data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
    } catch (error) {
      return;
    }

    if (data?.event === 'auth_result') {
      fireResult(buildTelegramAuthResult(data));
      popup?.close();
    }
  }

  if (!popup) {
    fireResult({error: 'popup_blocked'});
    return;
  }

  window.addEventListener('message', messageHandler);
  popup.focus();
  checkPopupClosed();
};

function Login() {
  const store = useStore();
  const [loading, setLoading] = useState(false);
  const [telegramLoading, setTelegramLoading] = useState(false);
  const [telegramError, setTelegramError] = useState('');
  const [authNetworkError, setAuthNetworkError] = useState(false);
  const [temporaryToken, setTemporaryToken] = useState('');
  const [telegramChoiceToken, setTelegramChoiceToken] = useState('');
  const [isTelegramChoiceModalOpen, setIsTelegramChoiceModalOpen] = useState(false);
  const telegramLoginEnabled = process.env.REACT_APP_TELEGRAM_LOGIN_ENABLED === 'true';
  const telegramClientId = process.env.REACT_APP_TELEGRAM_LOGIN_CLIENT_ID;
  const telegramScope = process.env.REACT_APP_TELEGRAM_LOGIN_SCOPE || TELEGRAM_DEFAULT_SCOPE;
  const useTelegramLogin = telegramLoginEnabled && !!telegramClientId;

  const submit = async (event) => {
    event.preventDefault();

    if (useTelegramLogin) {
      submitTelegramLogin();
      return;
    }

    await submitLegacyLogin();
  };

  const submitLegacyLogin = async () => {
    if (loading || authNetworkError) {
      return;
    }

    setLoading(true);
    setTelegramError('');
    setAuthNetworkError(false);

    try {
      const token = await ensureTemporaryToken({createIfMissing: true});

      if (isMobileDevice()) {
        openSocket(token);
        window.location.href = getTelegramBotDeepLink(token);
      } else {
        setTelegramChoiceToken(token);
        setIsTelegramChoiceModalOpen(true);
      }
    } catch (error) {
      console.error('Error starting Telegram authorization:', error);
      setTelegramError(NETWORK_ERROR_MESSAGE);
      setAuthNetworkError(true);
    } finally {
      setLoading(false);
    }
  };

  const submitTelegramLogin = () => {
    if (telegramLoading) {
      return;
    }

    if (!telegramClientId) {
      setTelegramError('Telegram Client ID is not configured.');
      return;
    }

    const clientId = Number(telegramClientId);

    if (Number.isNaN(clientId)) {
      setTelegramError('Telegram Client ID is invalid.');
      return;
    }

    setTelegramLoading(true);
    setTelegramError('');

    const nonce = createState();

    try {
      openTelegramPopup({
        clientId,
        scope: telegramScope,
        nonce,
        onResult: (authResult) => handleTelegramAuthResult(authResult, nonce),
      });
    } catch (error) {
      console.error('Telegram authorization error:', error);
      setTelegramError('Telegram authorization failed.');
      setTelegramLoading(false);
    }
  };

  const handleTelegramAuthResult = async (authResult, nonce) => {
    try {
      if (authResult?.error) {
        if (authResult.error === 'popup_closed') {
          setTelegramError('');
          return;
        }

        setTelegramError(authResult.error);
        return;
      }

      if (!authResult?.id_token) {
        setTelegramError('Telegram authorization failed.');
        return;
      }

      const {ip, locale, userAgent} = await getUserData();
      const result = await store.telegramAuth({
        idToken: authResult.id_token,
        telegramUser: authResult.user,
        nonce,
        ip,
        locale,
        userAgent,
      });

      if (!result?.success) {
        if (isTelegramUserNotFoundResult(result)) {
          setTelegramError('');
          redirectToAuthPage();
          return;
        }

        setTelegramError(result?.message || 'Telegram authorization failed.');
      }
    } catch (error) {
      console.error('Telegram authorization error:', error);
      setTelegramError('Telegram authorization failed.');
    } finally {
      setTelegramLoading(false);
    }
  };

  useEffect(() => {
    const version = process.env.REACT_APP_VERSION;
    localStorage.setItem('version', version);

    if (store.user?.main_token) {
      return;
    }

    store.clearUserAuthState();
    setTemporaryToken('');

    if (useTelegramLogin) {
      return;
    }

    let isMounted = true;

    const prepareStoredTemporaryToken = async () => {
      const storedTempToken = getStoredTemporaryToken();

      if (!storedTempToken) {
        return;
      }

      if (isMounted) {
        setLoading(true);
        setTelegramError('');
        setAuthNetworkError(false);
      }

      try {
        await getUsableStoredTemporaryToken();
      } catch (error) {
        console.error('Error preparing temporary token:', error);
        if (isMounted) {
          setTelegramError(NETWORK_ERROR_MESSAGE);
          setAuthNetworkError(true);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    prepareStoredTemporaryToken();

    return () => {
      isMounted = false;
    };
  }, []);

  const createState = () => {
    if (window.crypto?.getRandomValues) {
      const values = new Uint32Array(4);
      window.crypto.getRandomValues(values);
      return Array.from(values, (value) => value.toString(16)).join('');
    }

    return `${Date.now()}-${Math.random()}`;
  };

  const getStoredTemporaryToken = () => store.tokens?.tempToken || '';

  const getTemporaryTokenResponseStatus = (response) => response?.data?.status ?? response?.status;

  const getTemporaryTokenResponseCode = (response) => {
    const value =
      response?.code ||
      response?.error ||
      response?.message ||
      response?.data?.code ||
      response?.data?.error ||
      response?.data?.message;

    return typeof value === 'string' ? value : '';
  };

  const isTemporaryTokenActiveResponse = (response) => {
    const status = getTemporaryTokenResponseStatus(response);

    return (
      !!response?.success &&
      !!response?.data?.temp_token &&
      (status === undefined || Number(status) === 0)
    );
  };

  const isTemporaryTokenInactiveResponse = (response) => {
    const status = Number(getTemporaryTokenResponseStatus(response));
    const code = getTemporaryTokenResponseCode(response);

    return (
      status === 1 ||
      status === 2 ||
      code.includes(TEMP_TOKEN_ALREADY_USED) ||
      code.includes(TEMP_TOKEN_NOT_ACTIVE)
    );
  };

  const isStoredTemporaryTokenExpired = () => {
    const createdAt = Number(store.tokens?.createdAt);

    if (!createdAt || Number.isNaN(createdAt)) {
      return true;
    }

    const now = Date.now();

    return createdAt > now + TEMP_TOKEN_CLOCK_SKEW_MS || now - createdAt > TEMP_TOKEN_TTL_MS;
  };

  const ensureTemporaryToken = async ({createIfMissing}) => {
    const storedTempToken = await getUsableStoredTemporaryToken();

    if (storedTempToken) {
      return storedTempToken;
    }

    if (!createIfMissing) {
      return '';
    }

    return createTemporaryToken();
  };

  const getUsableStoredTemporaryToken = async () => {
    const storedTempToken = getStoredTemporaryToken();

    if (!storedTempToken) {
      return '';
    }

    const checkResult = await store.checkTemporaryToken(storedTempToken);

    if (!checkResult) {
      throw new Error('Temporary token check failed');
    }

    if (isTemporaryTokenInactiveResponse(checkResult)) {
      store.clearTemporaryToken();
      setTemporaryToken('');
      return '';
    }

    if (!isTemporaryTokenActiveResponse(checkResult)) {
      throw new Error('Temporary token check failed');
    }

    store.setTemporaryTokenData(checkResult.data);

    if (isStoredTemporaryTokenExpired()) {
      await revokeTemporaryToken(storedTempToken);
      return '';
    }

    setTemporaryToken(storedTempToken);
    return storedTempToken;
  };

  const revokeTemporaryToken = async (tempToken) => {
    const isRevoked = await store.revokeTempToken(tempToken);

    if (!isRevoked) {
      throw new Error('Temporary token was not revoked');
    }

    store.clearTemporaryToken();
    setTemporaryToken('');
  };

  const createTemporaryToken = async () => {
    const {ip, locale, userAgent} = await getUserData();
    const token = await store.getTemporaryToken(ip, locale, userAgent);

    if (token?.success) {
      const tempToken = token.data.temp_token;
      setTemporaryToken(tempToken);
      return tempToken;
    }

    throw new Error('Temporary token was not created');
  };

  const getUserData = async () => {
    try {
      const locale = Intl.DateTimeFormat('en-US', 'long').resolvedOptions().timeZone;
      const response = await store.getIp();
      const ip = response?.ip || response?.data?.ip;

      if (!ip) {
        throw new Error('User IP is missing');
      }

      return {ip, locale, userAgent: navigator.userAgent};
    } catch (error) {
      console.error('Error fetching IP information:', error);
      throw error;
    }
  };

  const openSocket = (temptoken) => {
    const channel = `user.${temptoken}`;
    const socket = io(process.env.REACT_APP_API_HOST_FOR_AUTH, {
      transports: ['polling', 'websocket'],
      query: {
        temp_token: temptoken,
      },
    });

    socket.on(channel, (e) => {
      store.setMainToken(e?.main_token);
      socket.disconnect();
    });

    socket.on('connect_error', (err) =>
      console.error('Socket connect_error:', err?.message || err)
    );
    socket.on('error', (err) => console.error('Socket error:', err));
  };

  const closeTelegramChoiceModal = () => {
    setIsTelegramChoiceModalOpen(false);
    setTelegramChoiceToken('');
  };

  const openSelectedTelegramAuth = (type) => {
    const token = telegramChoiceToken;

    closeTelegramChoiceModal();

    if (!token) {
      return;
    }

    openSocket(token);

    if (type === 'app') {
      window.location.href = getTelegramBotDeepLink(token);
      return;
    }

    openTelegramAuthWindow(getTelegramWebUrl(token));
  };

  return (
    <div className='form w-100'>
      <style>{TELEGRAM_CHOICE_MODAL_STYLES}</style>
      <div className='d-grid mb-10'>
        <button
          type='submit'
          className={`btn ${authNetworkError ? 'btn-secondary' : 'btn-primary'}`}
          onClick={submit}
          disabled={useTelegramLogin ? telegramLoading : loading || authNetworkError}
        >
          {useTelegramLogin && !telegramLoading && (
            <>
              <i className='bi bi-telegram'></i>
              <span className='indicator-label'>Войти через Telegram</span>
            </>
          )}
          {!useTelegramLogin && !loading && (
            <>
              <svg
                width='16'
                height='16'
                viewBox='0 0 24 24'
                fill='none'
                style={{marginRight: 8}}
                aria-hidden='true'
              >
                <path
                  d='M14 3H6.75C5.78 3 5 3.78 5 4.75v14.5C5 20.22 5.78 21 6.75 21H14'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M10 12h10m0 0-3.25-3.25M20 12l-3.25 3.25'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
              <span className='indicator-label'>Войти в систему</span>
            </>
          )}
          {((useTelegramLogin && telegramLoading) || (!useTelegramLogin && loading)) && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>

      {!!telegramError && <div className='text-danger text-center'>{telegramError}</div>}

      {isTelegramChoiceModalOpen && (
        <div className='telegram-choice-modal'>
          <div className='telegram-choice-modal__panel'>
            <button
              type='button'
              className='telegram-choice-modal__close'
              onClick={closeTelegramChoiceModal}
              aria-label='Закрыть'
            >
              ×
            </button>

            <div className='telegram-choice-modal__icon'>
              <svg width='72' height='72' viewBox='0 0 44 44' fill='none'>
                <path
                  d='M35.64 9.5L7.92 20.2C6.03 20.96 6.04 22 7.57 22.47L14.69 24.69L31.16 14.3C31.94 13.82 32.65 14.08 32.07 14.6L18.73 26.64H18.72L18.73 26.65L18.24 33.96C18.96 33.96 19.28 33.63 19.68 33.24L23.14 29.88L30.34 35.2C31.67 35.93 32.62 35.56 32.95 33.97L37.68 11.68C38.16 9.74 36.94 8.86 35.64 9.5Z'
                  fill='white'
                />
              </svg>
            </div>

            <div className='telegram-choice-modal__title'>
              Выберите какую версию телеграм вы используете
            </div>

            <button
              type='button'
              className='telegram-choice-modal__button telegram-choice-modal__button--app'
              onClick={() => openSelectedTelegramAuth('app')}
            >
              Приложение
            </button>

            <button
              type='button'
              className='telegram-choice-modal__button telegram-choice-modal__button--web'
              onClick={() => openSelectedTelegramAuth('web')}
            >
              WEB
            </button>

            <button
              type='button'
              className='telegram-choice-modal__button telegram-choice-modal__button--close'
              onClick={closeTelegramChoiceModal}
            >
              Закрыть
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default observer(Login);
